import { Controller } from "stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  static targets = ["modal", "uploadForm", "preview", "previewImage"];

  initialize() {
    console.log("Attachment upload controller initialized");
  }

  connect() {
    console.log("Attachment upload controller connected");
    // Initialize the modal
    const modalElement = this.modalTarget;
    if (modalElement) {
      this.modal = new bootstrap.Modal(modalElement);
      console.log("Modal initialized:", this.modal);
    } else {
      console.error("Modal element not found");
    }
  }

  disconnect() {
    console.log("Attachment upload controller disconnected");
    if (this.modal) {
      this.modal.dispose();
    }
  }

  show(event) {
    event.preventDefault();
    console.log("Showing upload modal");
    if (this.modal) {
      this.modal.show();
    } else {
      console.error("Modal not initialized");
    }
  }

  previewUpload(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewImageTarget.src = e.target.result;
        this.previewTarget.style.display = "block";
      };
      reader.readAsDataURL(file);
    }
  }

  async uploadToLibrary(event) {
    event.preventDefault();
    const formData = new FormData();

    // Get form elements using their IDs
    const fileInput = this.uploadFormTarget.querySelector("#file");
    const nameInput = this.uploadFormTarget.querySelector("#name");
    const descriptionInput =
      this.uploadFormTarget.querySelector("#description");
    const typeInput = this.uploadFormTarget.querySelector("#attachment_type");

    // Validate inputs
    if (!fileInput || !nameInput || !descriptionInput || !typeInput) {
      console.error("Missing form elements");
      alert("Form elements not found. Please refresh the page and try again.");
      return;
    }

    // Add file if present
    if (fileInput.files[0]) {
      formData.append("file", fileInput.files[0]);
    }

    // Add other fields
    formData.append("scenario_attachment[name]", nameInput.value);
    formData.append("scenario_attachment[description]", descriptionInput.value);
    formData.append("scenario_attachment[attachment_type]", typeInput.value);

    try {
      const response = await fetch("/scenario_attachments", {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
            .content,
          Accept: "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();

        // Find the scenario_attachment_id input in the current form
        const scenarioAttachmentIdInput = this.element.querySelector(".att-id");
        const nameField = this.element.querySelector(".att-name");
        const attachmentActions = this.element.querySelector(
          ".attachment-actions"
        );

        if (scenarioAttachmentIdInput) {
          // Update the value with the new attachment ID
          scenarioAttachmentIdInput.value = data.id;

          // Update the name display
          if (nameField) {
            nameField.textContent = data.name;
          }

          // Hide the attachment actions
          if (attachmentActions) {
            attachmentActions.style.display = "none";
          }

          // Trigger change event
          scenarioAttachmentIdInput.dispatchEvent(new Event("change"));
        }

        // Close the modal
        this.modal.hide();
      } else {
        const errorText = await response.text();
        console.error("Upload failed:", errorText);
        throw new Error("Upload failed: " + errorText);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Failed to upload file. Please try again.");
    }
  }
}
